import type { CrosswordsType } from "@product/scmp-sdk";

export const pathname = "/games/crossword/:date";

export const page = {
  route(query: QueryParameters<{ crosswordsType?: CrosswordsType; entityId?: string }>) {
    const { entityId, ...restQuery } = query;

    if (entityId) {
      return {
        pathname: `/games/crossword/${entityId}`,
        query: {
          ...restQuery,
          date: entityId,
          pageType: "game-crossword",
        },
      };
    }

    return {
      pathname: "/games/crossword",
      query: {
        ...restQuery,
        pageType: "game-crossword",
      },
    };
  },
};
